export const rggold = () => {
    return(
        <div>
            <h1>Кейс: Автоматизация МТО и ТОиР в RG Gold – Оптимизация закупок и техобслуживания</h1>

            <h2>О компании RG Gold</h2>
            <p><strong>RG Gold</strong> – одно из ведущих золотодобывающих предприятий Казахстана, использующее современные технологии добычи и переработки руды. Компания активно инвестирует в цифровизацию бизнес-процессов для повышения прозрачности, скорости и эффективности управления ресурсами.</p>

            <h2>Задачи проекта</h2>
            <ul>
                <li>Отсутствие единого цифрового контура для закупок, бюджетирования и управления складом.</li>
                <li>Высокая трудоемкость согласования заявок на закупки и ремонт оборудования.</li>
                <li>Отсутствие интеграции 1С:КУБиФ с процессами закупок, учета ТМЦ и документооборотом.</li>
                <li>Низкая прозрачность и контроль сроков поставок и исполнения контрактов.</li>
                <li>Необходимость учета критичности номенклатуры и оптимизации складских остатков.</li>
            </ul>

            <h2>Решение</h2>
            <p>Группа Компаний Кибернетика реализовала комплексную автоматизацию бизнес-процессов в модулях МТО и 1С:ТОиР с глубокой интеграцией в 1С:КУБиФ.</p>

            <h3>Автоматизация закупочного процесса в 1С:КУБиФ</h3>
            <ul>
                <li>Разработан механизм планирования закупок с учетом остатков.</li>
                <li>Внедрен модуль «План закупок» с автоматическим расчетом бюджетов.</li>
                <li>Реализация классификации критичности запасов и аналогов.</li>
                <li>Формирование годового и поквартального плана закупок.</li>
                <li>Контроль закрытия месяцев и ошибок планирования.</li>
            </ul>

            <h3>Оптимизация работы мостов</h3>
            <ul>
                <li>Разработка интерфейсов выгрузки данных в 1С:КУБиФ.</li>
                <li>Обновление статусов поставок с автоматическим обновлением.</li>
                <li>Автоматическое определение и фиксация конечной стоимости в тенге.</li>
            </ul>

            <h3>Автоматизация технического обслуживания и ремонта (ТОиР)</h3>
            <ul>
                <li>Учет оборудования, заявок на обслуживание и ремонты.</li>
                <li>Планирование и анализ на уровне конструктивных узлов.</li>
                <li>Формирование заявок на закупку запасных частей.</li>
                <li>Автоматизация процессов согласования и учета заказов.</li>
            </ul>

            <h3>Интеграция 1С:КУБиФ и 1С:Документооборот</h3>
            <ul>
                <li>Внедрение единого контура для планирования и управления.</li>
                <li>Электронный документооборот для согласования договоров.</li>
                <li>Автоматический отчет НАДЛОК для аналитики бюджета.</li>
            </ul>

            <h2>Результаты</h2>
            <ul>
                <li>Сокращение сроков закупок на 30%.</li>
                <li>Снижение складских остатков на 25%, снижение неликвидов на 15%.</li>
                <li>Прозрачность цепочки согласования и контроля исполнения.</li>
                <li>Снижение трудозатрат на закупки на 25%.</li>
                <li>Сокращение объемов ручного ввода на 40% благодаря интеграции с 1С:Документооборот.</li>
                <li>Полный контроль бюджета закупок из 1С:КУБиФ.</li>
            </ul>
        </div>
    )
}